<template>
  <v-dialog v-model="dialog" max-width="900px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("App.order_rule") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false; $emit('cancel')">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <span  v-html = help_order_rule_html></span>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Settings from "@/api/settings";
export default {
  name: "DialogOrderRule",

  props: {
    value: Boolean,
  },

  data: () => ({
    dialog: false,
    help_order_rule_html: ""
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.value) {
          Settings.getSettings({keys:["help_order_rule_html"]}).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.help_order_rule_html = response.data.settings.help_order_rule_html
              }
            }.bind(this)
          )
        }
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.$emit("close");
      },
    },
  },
};
</script>
